import { preloadPostOfficeConfluenceSideNav } from '@confluence/experiment-post-office-side-nav/entry-points/preloadConfluenceSideNav';
import { fg } from '@confluence/feature-gating';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList';
import { FORGE_MODULE_SPACE_PAGE } from '@confluence/forge-ui/entry-points/ForgeModuleType';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';
import { getIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/getIsNav4Enabled';
import { expVal } from '@confluence/feature-experiments';
import { preloadPersistentInviteButtonEligible } from '@confluence/persistent-invite-button/entry-points/preloadPersistentInviteEligible';
import { preloadOptionalNthUserGuidedTour } from '@confluence/experiment-enhance-orientation-tour/entry-points/preloadOptionalNthUserGuidedTour';

import { SpaceNavigationQuery } from './SpaceNavigation/SpaceNavigationQuery.graphql';

export async function preloadSideNavigationNeedsContentId(spaceKey: string, contentId: string) {
	if (expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return Promise.resolve();
	}

	return expVal('confluence_fix_space_apps_flickering', 'isEnabled', false)
		? preloadUseExtensionList({
				spaceKey,
				moduleType: FORGE_MODULE_SPACE_PAGE,
			})
		: preloadUseExtensionList({
				contentId,
				spaceKey,
				moduleType: FORGE_MODULE_SPACE_PAGE,
			});
}

export async function preloadSideNavigation(spaceKey: string) {
	const preloadedSessionContext = getPreloaderFnContext();
	const isNav4Enabled = getIsNav4Enabled();

	const tasks: Array<Promise<any>> = [];

	if (!expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		tasks.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: SpaceNavigationQuery,
				variables: {
					spaceKey,
					isLicensed: preloadedSessionContext.isLicensed,
				},
			}),
		);
	}

	tasks.push(
		preloadPersistentInviteButtonEligible(
			{ spaceKey },
			expVal('confluence_unified_space_preloader', 'isEnabled', false),
		),
	);

	if (isNav4Enabled) {
		tasks.push(
			preloadWebItemLocation({
				location: 'system.header/left',
			}),
		);
		if (fg('cc_engagement_optional_guided_tour_for_nth_users')) {
			tasks.push(preloadOptionalNthUserGuidedTour());
		}
	}

	if (fg('po-connie-side-nav-ssr-shadow')) {
		tasks.push(preloadPostOfficeConfluenceSideNav(preloadedSessionContext));
	}

	return waitForAllReturnWhenError(tasks);
}
